<template>
  <div class="footer">
    <div :class="['footer-content', isMobile ? 'isMobile' : '']">
      <div class="footer-content-column">
        <div class="title">Product Catalog</div>
        <div
          :class="['item', currentPath === product.route ? 'active' : '']"
          v-for="product in products"
          :key="product.title"
          @click="productClik(product.route)"
        >
          ☞ {{ product.title }}
        </div>
      </div>
      <div class="footer-content-column">
        <div class="title">Quick Navigation</div>
        <div
          :class="['item', currentPath === nav.path ? 'active' : '']"
          v-for="nav in navs"
          :key="nav.title"
          @click="productClik(nav.path)"
        >
          ☞ {{ nav.title }}
        </div>
      </div>
      <div class="footer-content-column">
        <div class="title">Henan Yixiang Chemical Co., Ltd.</div>
        <!-- <div><i class="iconfont icon-ai-tel"></i> {{ commom.phone }}</div> -->
       
        <div>
          <i class="iconfont icon-youxiang" />
          <el-link
            :href="`mailto:${commom.email}`"
            style="margin-left: 4px"
            type="primary"
            >{{ commom.email }}</el-link
          >
        </div>
        <div>
          <i class="iconfont icon-wangluo" />
          <el-link
            href="http://www.yixiangchemical.com"
            style="margin-left: 4px"
            type="primary"
            target="_blank"
            >{{ commom.websit }}</el-link
          >
        </div>
         <div><i class="iconfont icon-zhuzhi"></i> {{ commom.addressEn }}</div>
      </div>
    </div>
    <div class="footer-tips">
      <p>
        Copyright © Henan Yixiang Chemical Co., Ltd. All rights reserved.
        Sitemap
      </p>
      <!-- <p><i class="iconfont icon-ai-tel"></i> {{ commom.phone }}</p> -->
    </div>
  </div>
</template>

<script>
import commom from "@/commom";
const products = [
  { title: "Solvents", route: "/Solvents" },
  { title: "Coating", route: "/Coating" },
  { title: "Others", route: "/Others" },
];

const navs = [
  { title: "Home", path: "/home" },
  { title: "About Us", path: "/aboutUs" },
  { title: "Products", path: "/Products" },
  { title: "Contact Us", path: "/contactUs" },
];

export default {
  name: "Footer",
  computed: {
    currentPath() {
      return this.$route.path; // 获取当前路由的路径
    },
  },
  data() {
    return {
      isMobile: this.$isMobile,
      commom,
      products,
      navs,
    };
  },
  methods: {
    productClik(path) {
      this.$router.push(path);
      this.$bus.$emit("myScrollTop");
    },
  },
};
</script>

<style lang="less" scoped>
@color: #fff;
@bgColor: #303133;
.footer {
  background-color: @bgColor;
  padding-top: 20px;
  padding-bottom: 5px;
  margin-top: 20px;
  font-size: 12px;
  color: @color;
  &-content {
    display: flex;
    justify-content: center;
    border-bottom: solid gray 1px;
    padding-bottom: 20px;
    column-gap: 100px;
    &-column {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      .title {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 14px;
      }
      .item {
        cursor: pointer;
        // color: #e6a23c;
        &:hover {
          color: @headerBgColor;
        }
      }
    }
  }
  .isMobile {
    column-gap: 20px;
  }
  .footer-tips {
    color: #999999;
    text-align: center;
    > p {
      height: 20px;
      line-height: 20px;
    }
  }
  .active {
    color: @headerBgColor;
  }
}
</style>
